"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberOrNull = void 0;
function getNumberOrNull(val) {
    if (val === null || val === undefined) {
        return null;
    }
    const numVal = Number(val);
    if (isNaN(numVal)) {
        return null;
    }
    return numVal;
}
exports.getNumberOrNull = getNumberOrNull;
//# sourceMappingURL=getNumberOrNull.js.map